import { useUpdateMission } from "features/pilot-tracking/flights-page/PilotTrackingMissionQueries"
import { useParams } from "react-router"
import { ComponentType, useState } from "react"
import { ClickAwayListenerV2 } from "@nova/component-click-away-listener"
import { TextAreaOutlined } from "@nova/ds-component-input"
import { Card } from "../../MetricLayout"
import { ButtonTertiary } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"
import { useWorkspacePermissions } from "features/data-management/workspace/useWorkspacePermissions"

export const NotesCard = ({ notes }: { notes: string | null }) => {
    const { missionId = "" } = useParams()
    const { updateMission } = useUpdateMission(missionId)

    return (
        <Card className="flex flex-col gap-1 flex-1 !px-3">
            <h2 className="text-white px-2 telegraf">Notes</h2>
            <EditableNotes
                notes={notes}
                onSave={(notes) => updateMission({ notes })}
                EmptyComponent={AddNoteButton}
            />
        </Card>
    )
}

const AddNoteButton = ({ startEditing }: { startEditing: () => void }) => (
    <div className="pl-2 pt-1">
        <ButtonTertiary title="Note" LeftIcon={Icons.Plus} onClick={startEditing} />
    </div>
)

export const EditableNotes = ({
    notes,
    onSave,
    EmptyComponent,
}: {
    notes: string | null
    onSave: (notes: string) => void
    EmptyComponent: ComponentType<{ startEditing: () => void }>
}) => {
    const { isEditor } = useWorkspacePermissions()
    const [isEditingNotes, setIsEditingNotes] = useState(false)
    const [localNotes, setLocalNotes] = useState(notes || "")

    const startEditing = () => setIsEditingNotes(true)

    const handleSaveNotes = () => {
        onSave(localNotes)
        setIsEditingNotes(false)
    }

    return isEditingNotes ? (
        <ClickAwayListenerV2 onClickAway={handleSaveNotes}>
            <TextAreaOutlined
                autoFocus
                onFocus={(e) =>
                    e.currentTarget.setSelectionRange(localNotes.length, localNotes.length)
                }
                value={localNotes}
                onChange={(e) => setLocalNotes(e.currentTarget.value)}
                rows={3}
            />
        </ClickAwayListenerV2>
    ) : !isEditor ? (
        <div className="w-full h-full py-1.5 px-2 rounded-md whitespace-pre-wrap break-words">
            {localNotes}
        </div>
    ) : localNotes ? (
        <div
            className="w-full h-full py-1.5 px-2 rounded-md whitespace-pre-wrap break-words hover:bg-gray-700 hover:text-white transition-colors cursor-pointer"
            onClick={startEditing}
        >
            {localNotes}
        </div>
    ) : (
        <EmptyComponent startEditing={startEditing} />
    )
}
